import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import Select from 'react-select';
import {DealerRole,Persona} from '../RolesAndPersona/RolesAndPersona'

const UserRegistration = () => {
    const [validated, setValidated] = useState(false);
    const [userType, setuserType] = useState("Member");
    const [EmailAdress, setEmail] = useState("");
    const [isLoading, setIsloading] = useState(false);
    const [issuccess, setsuccess] = useState(false);
    const [iserror, seterror] = useState(false);
    const [userGroup, setuserGroup] = useState("");
    const [RLType, setRLtype] = useState('');
    const [iserrorEmail, setiserrorEmail] = useState(false);

    const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))[
      "accessToken"
    ];
  
   // console.log("passtoken")
    //console.log(userGroup)
  
    useEffect(() => {
      document.title = "User Registration";
    });
  
    var SelectedList = ["daimlertruck.com","tbdir.net"];

    const emailid  = localStorage.getItem("myemail");
    const handleSubmit = (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      var splitArray = EmailAdress.split('@');

      // console.log(form);
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      } 
      else {
       
        if(SelectedList.indexOf(splitArray[1]) >= 0){
          setValidated(true);
          setIsloading(true);
  
          const data = {
            emailAddress: EmailAdress.toLowerCase(),
            userType: userType,
            userGroup:selectedPersona1,
            rlType:selectedOptionsDataRl,
            assignUser:emailid
          }
          const url = `${process.env.REACT_APP_SERVER_URL}/aipd/registerUser `;

          const header = {
            headers: {
              "oidc-token": passtoken,
            }
          }
  
          axios.post(url, data, header)
  
            .then(function (response) {
              if (response.status === 201) {
                // console.log(response);
                setIsloading(false)
                setValidated(false)
                setuserType("Member")
                setEmail("")
                setuserGroup("")
                setRLtype("")
                setsuccess(true)
                setTimeout(() => {
                  setsuccess(false);
                }, 10000);
                seterror(false);
              }
            })
            .catch(function (error) {
              // console.log(error);
              setIsloading(false);
              setValidated(false);
              setsuccess(false);
              seterror(true);
              setTimeout(() => {
                seterror(false);
              }, 10000);
            });
        }
        else{
          setiserrorEmail(true)
          setTimeout(() => {
            setiserrorEmail(false)
          }, 5000);

        }
       
      }
      setValidated(true);
    };

   
  
   
    const resetForm = (e) => {
      e.preventDefault();
      setValidated(false)
      setuserType("Member")
      setEmail("")
      setuserGroup("")
      setRLtype("")
      setSelectedOptions([])
      setselectedOptionsData([])
      setselectedOptionsPersona([])
      setselectedPersona([])
    };

   

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsData, setselectedOptionsData] = useState([]);
    const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);

    const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
    const [selectedPersona, setselectedPersona] = useState([]);
    const [selectedPersona1, setselectedPersona1] = useState([]);

    const handleChange = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setSelectedOptions(selectedOptions)
      const userGroupsArrayRLtype = selectedValues.map((value) => ({ "RLtypename": value }));

      setselectedOptionsData(selectedValues);
      setselectedOptionsDataRl(userGroupsArrayRLtype);

    };

    const handleChangePersona = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setselectedOptionsPersona(selectedOptions)
      setselectedPersona(selectedValues);
      const userGroupsArray = selectedValues.map((value) => ({ "userGroupId": value }));

      setselectedPersona1(userGroupsArray);
    };
  

    const findUsernameFromGmail = (gmailAddress) => {
        const parts = gmailAddress.split("@");
        if (parts.length === 2) {
            const usernameWithDot = parts[0]; // e.g., "nabasundar.rout"
            const usernameParts = usernameWithDot.split(".");
            if (usernameParts.length >= 2) {
                const firstName = capitalize(usernameParts[0]);
                const lastName = capitalize(usernameParts[1]);
                // Handle cases where last name has more than one part
                const lastNameRest = usernameParts.slice(2).join(" ");
                return firstName + " " + lastName + (lastNameRest ? " " + lastNameRest : "");
            } else {
                return "Invalid Gmail address. Must contain both first and last name.";
            }
        } else {
            return "Invalid Gmail address";
        }
    };
    
    // Helper function to capitalize first letter of a string
    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    
  return (
    <div id="userRegId">
       
      <div>
    
          <div id="Create_users_id">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="validationCustom01Email">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    className="validationCustom01Email"
                    autoComplete="off"
                    required
                    type="email"
                    placeholder="Email Address"
                    value={EmailAdress}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Email Address is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom02">
                  <Form.Label>User Type *</Form.Label>

                  <Form.Select
                    required
                    value={userType}
                    onChange={(e) => setuserType(e.target.value)}
                  >
                    <option value="Member">Member</option>
                    <option value="Admin">Admin</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    User Type is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom03Pesona">
                  <Form.Label>Group Type *</Form.Label>

                  <Select
                options={Persona}
                required
                isMulti
                placeholder="Select Group Types"
                value={selectedOptionsPersona}
                onChange={handleChangePersona}
                className="RlTypesCls"
        
              />

                  {/* <Form.Select
                    required
                    value={userGroup}
                    onChange={(e) => setuserGroup(e.target.value)}
                  >
                    
                  </Form.Select> */}
                  <Form.Control.Feedback type="invalid">
                    Group Type is required *
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row className="mb-3">
             
              <Form.Group as={Col} md="4" controlId="validationCustom04RLType">
              <Form.Label>Roles*</Form.Label>

              <Select
                options={DealerRole}
                required
                isMulti
                placeholder="Select Roles"
                value={selectedOptions}
                onChange={handleChange}
                className="RlTypesCls"

        
              />
               <Form.Control.Feedback type="invalid">
               RL Types is required *
                  </Form.Control.Feedback>
              </Form.Group>

               
              
              </Row>

              <div
                style={{ gridGap: "10px", display: "flex", marginTop: "1rem" }}
                className="mb-3"
              >
               
                <Button onClick={resetForm} className="cancel_btn" type="reset">
                  {" "}
                  Reset
                </Button>

                <Button  disabled={isLoading} className="submit_btn" type="submit">
                  
                  {isLoading 
                ? 
                <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span style={{paddingLeft:"10px"}}>Adding...</span>
              </> 

                : "Register"}
                </Button>
              </div>
            </Form>
          </div>
        

        {issuccess && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="success"
            >
              <p className="mb-0">User Successfully Registered</p>
            </Alert>
          </div>
        )}

        {iserror && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                  User already exists
              </p>
            </Alert>
          </div>
        )}

        {iserrorEmail && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                Please use '@daimlertruck.com' and '@tbdir.com' email id 

              </p>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserRegistration
